import { dataStateType } from "src/constants/status";
import { contextDeviceColumns as columns } from "../../Helper";

const GetContextDeviceColumns = ({ handleDelete, status }) => {
  // const actionCol = {
  //   key: "actions",
  //   label: "Actions",
  //   align: "center",
  //   render: (item) => (
  //     <Box
  //       sx={{
  //         display: "flex",
  //         justifyContent: "center",
  //         minWidth: "120px",
  //       }}
  //     >
  //       {allowedToDeleteEntity(auth?.permissions, permissionsAccessControl) && (
  //         <button className="btn btn-danger" onClick={() => handleDelete(item)}>
  //           <i className="bx bx-trash"></i>
  //         </button>
  //       )}
  //     </Box>
  //   ),
  // };

  if (status === dataStateType.ACTIVE) {
    return [...columns];
  }

  return columns;
};

export default GetContextDeviceColumns;
